import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

export default function WhatsAppButton(props) {
  return (
    <div
      id="whats-app-floating-btn"
      style={{ background: props.whatsAppColor }}
    >
      <a
        href={`https://wa.me/${props.whatsAppNumber}?text=Gostaria%20de%20iniciar%20atendimento%20do%20Grupo%20Krause.`}
        rel="noopener noreferrer"
        className="whats-app-btn-link"
        target="_blank"
        aria-label="Entre em contato via WhatsApp"
        style={{ color: props.white }}
      >
        <FaWhatsapp className="whats-app-btn-icon" />
      </a>
    </div>
  );
}
